/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum NoradIcon {
  None = "None",
  Pdf = "Pdf",
  Doc = "Doc",
  Xls = "Xls",
  RightArrow = "RightArrow",
  Link = "Link",
  Student = "Student",
  Notebook = "Notebook",
  Toolbox = "Toolbox",
  ChatCircleTextIcon = "ChatCircleTextIcon",
}
